import { fromNode, ViewModel } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

export class URLParameterModel extends ViewModel {
  @reactive()
  __r_value?: null | string | undefined

  /**
   * url 参数名称
   */
  @fromNode()
  @reactive()
  name?: string

  get hash() {
    return location.hash.replace(/^(#|%23)/, '')
  }

  get hashSearch() {
    return new URLSearchParams(this.hash)
  }

  /**
   * url 参数值
   */
  @fromNode()
  get value() {
    return this.__r_value ?? this.__r_getHashValue()
  }

  set value(value: any) {
    this.__r_setHashValue(value)
    this.__r_value = this.__r_getHashValue()
  }

  __r_getHashValue() {
    const search = new URLSearchParams(this.hash)
    return this.name && search.get(this.name)
  }

  __r_setHashValue(value: any) {
    const search = this.hashSearch
    if (this.name) {
      search.set(this.name, value)
      location.hash = search.toString()
    }
  }
}
